function getDataFromSendFileMetaTag(message) {
  let regexSendFile = '%SendFile%(.+?)%/SendFile%'
  let regexFilename = '%Filename%(.+?)%/Filename%'
  let regexUrl = '%Url%(.+?)%/Url%'
  let regexApp = '%App%(.+?)%/App%'

  let tagSendFile = message.match(regexSendFile)
  let tagFilename
  let tagUrl
  let tagApp

  let filename, app, url, type

  if (tagSendFile) {
    tagFilename = tagSendFile[0].match(regexFilename)
    tagUrl = tagSendFile[0].match(regexUrl)
    tagApp = tagSendFile[0].match(regexApp)

    if (tagFilename) {
      filename = tagFilename[0].replace('%Filename%', '')
      filename = filename.replace('%/Filename%', '')
    }
    if (tagApp) {
      app = tagApp[0].replace('%App%', '')
      app = app.replace('%/App%', '')
    }
    if (tagUrl) {
      url = tagUrl[0].replace('%Url%', '')
      url = url.replace('%/Url%', '')

      type = url.substring(url.lastIndexOf('.') + 1)

      if ((app && app === 'IXC') || (app && app === 'MKAUTH')) {
        if (url.substr(-5) === '.html') {
          url = url.substring(0, url.length - 5)
        }
      }
    }
    if (url) {
      return {
        filename: filename,
        url: url,
        type: type,
        app: app,
      }
    }
  }
  return undefined
}

function clearMetaTagMessage(message) {
  return message.replace(/(%SendFile%)(.*)(%\/SendFile%)/g, '')
}

function clearMetaTagPix(message, value = '') {
  return message.replace(/(%Pix%)((.|\r|\n|\t)*)(%\/Pix%)/g, value)
}

function clearMetaTagPaymentLink(message, value = '') {
  return message.replace(/(%PaymentLink%)((.|\r|\n|\t)*)(%\/PaymentLink%)/g, value)
}

function getFileFromMessage(message) {
  return getDataFromSendFileMetaTag(message)
}

function clearMessage(message) {
  return clearMetaTagMessage(message)
}

function formatMessage(message, { link = '' } = {}) {
  let msg = clearMetaTagMessage(message)
  msg = clearMetaTagPix(msg, link)
  msg = clearMetaTagPaymentLink(msg, link)
  return msg
}

function getPaymentLinkThumbnail(message) {
  const regexPixThumbnail = /(?<=%PixThumbnail%)((.|\r|\n|\t)*)(?=%\/PixThumbnail%)/g // DEPRECATED, REMOVER EM BREVE
  const pixThumbnail = message.match(regexPixThumbnail) // DEPRECATED, REMOVER EM BREVE

  const regexThumbnail = /(?<=%Thumbnail%)((.|\r|\n|\t)*)(?=%\/Thumbnail%)/g
  const thumbnail = message.match(regexThumbnail)

  if(!thumbnail && !pixThumbnail) return null

  return thumbnail?.length ? thumbnail[0] : pixThumbnail[0]
}

function getWhatsappCloudApiTemplateName(message) {
  const regexWhatsappCloudApi = /(?<=%WhatsappCloudApi%)((.|\r|\n|\t)*)(?=%\/WhatsappCloudApi%)/g
  const whatsappCloudApiContent = message.match(regexWhatsappCloudApi)

  if(!whatsappCloudApiContent || !whatsappCloudApiContent?.length) return null
  
  const content = whatsappCloudApiContent[0]

  const regexTemplateName = /(?<=%Name%)((.|\r|\n|\t)*)(?=%\/Name%)/g
  const templateName = content.match(regexTemplateName)

  if(!templateName || !templateName.length) return null

  return templateName[0]
}

// Pega TODAS as ocorrências do conteúdo entre uma metatag (não-guloso) e
// devolve cada uma já trimada. Vazio -> []. Usado para campos repetidos
// (variáveis e botões do template Meta).
function getAllMetaTagContents(regex, message) {
  const matches = message.match(regex)
  return matches ? matches.map((value) => value.trim()) : []
}

// Lê o template Meta Oficial do payload e devolve os dados que dá pra mostrar
// pro cliente leigo: nome, variáveis preenchidas (em ordem), preço e se há
// botão de link de pagamento. Retorna null quando não é template Meta.
function getWhatsappCloudApiTemplateData(message) {
  if (!message || !/%WhatsappCloudApi%/.test(message)) return null

  const variables = getAllMetaTagContents(
    /(?<=%VariableNumeric%)([\s\S]*?)(?=%\/VariableNumeric%)/g,
    message
  )
  const buttons = getAllMetaTagContents(
    /(?<=%ButtonUrl%)([\s\S]*?)(?=%\/ButtonUrl%)/g,
    message
  )

  const priceMatch = message.match(/(?<=%Price%)([\s\S]*?)(?=%\/Price%)/g)
  const price = priceMatch && priceMatch.length ? priceMatch[0].trim() : null

  return {
    templateName: getWhatsappCloudApiTemplateName(message),
    variables,
    buttons,
    price,
    hasPaymentButton: buttons.some((url) => /PAYMENT_LINK/i.test(url)),
    thumbnail: getPaymentLinkThumbnail(message),
  }
}

// Rótulos amigáveis para as variáveis. Templates no padrão matriz_<erp>_<cenário>
// seguem a ordem fixa do gerador; fora do padrão, cai em "Campo N".
function getTemplateVariableLabels(templateName, count) {
  const MATRIZ_LABELS = ['Cliente', 'Contrato', 'Nº da fatura', 'Vencimento', 'Valor']
  const isMatriz = typeof templateName === 'string' && templateName.startsWith('matriz_')

  return Array.from({ length: count }, (_, index) =>
    isMatriz && MATRIZ_LABELS[index] ? MATRIZ_LABELS[index] : `Campo ${index + 1}`
  )
}

// Substitui os placeholders {{n}} pelos valores enviados (na ordem). Quando não
// há valor para um {{n}}, mantém o placeholder — assim o preview deixa explícito
// o que não foi preenchido em vez de inventar.
function fillPlaceholders(text, values) {
  if (!text) return text
  const list = Array.isArray(values) ? values : []
  return text.replace(/\{\{(\d+)\}\}/g, (match, number) => {
    const value = list[Number(number) - 1]
    return value != null && value !== '' ? value : match
  })
}

// Quebra um texto em pedaços marcando o que veio de variável. Divide em cima dos
// {{n}}: cada {{n}} com valor correspondente vira um token { kind: 'var' } com o
// valor enviado; {{n}} sem valor permanece literal (kind 'static'), preservando o
// comportamento de "deixar explícito o que não foi preenchido". Quem renderiza
// decide o destaque visual — aqui é só dado puro, fácil de testar.
function tokenizeFilledText(text, values) {
  if (!text) return []
  const list = Array.isArray(values) ? values : []
  const parts = text.split(/(\{\{\d+\}\})/g)
  const tokens = []
  for (const part of parts) {
    if (part === '') continue
    const match = part.match(/^\{\{(\d+)\}\}$/)
    if (match) {
      const value = list[Number(match[1]) - 1]
      if (value != null && value !== '') {
        tokens.push({ kind: 'var', text: String(value) })
      } else {
        tokens.push({ kind: 'static', text: part })
      }
    } else {
      tokens.push({ kind: 'static', text: part })
    }
  }
  return tokens
}

// Regras de formatação do WhatsApp, na ordem em que tentamos casar. Conteúdo
// vazio entre marcadores não conta; marcador solto fica literal (igual ao app).
// `mono` não recursa (o conteúdo é literal); os demais aceitam aninhamento.
const WHATSAPP_MARKDOWN_RULES = [
  { type: 'codeblock', re: /```([\s\S]+?)```/, literal: true },
  { type: 'code', re: /`([^`\n]+?)`/, literal: true },
  { type: 'bold', re: /\*([^*\n]+?)\*/ },
  { type: 'italic', re: /_([^_\n]+?)_/ },
  { type: 'strike', re: /~([^~\n]+?)~/ },
]

// Faz o parse do markdown do WhatsApp e devolve uma AST simples (sem React),
// pronta pra renderizar. Ex.: "Olá *{{1}}*" -> [texto "Olá ", bold[ texto "{{1}}" ]].
// Mantém os {{n}} intactos no texto — o destaque de variável é aplicado depois,
// na renderização, por cima desta árvore.
function parseWhatsappMarkdown(text) {
  if (text == null || text === '') return []

  let earliest = null
  for (const rule of WHATSAPP_MARKDOWN_RULES) {
    const match = text.match(rule.re)
    if (match && (earliest === null || match.index < earliest.match.index)) {
      earliest = { rule, match }
    }
  }

  if (!earliest) return [{ type: 'text', value: text }]

  const { rule, match } = earliest
  const before = text.slice(0, match.index)
  const after = text.slice(match.index + match[0].length)
  const nodes = []

  if (before) nodes.push(...parseWhatsappMarkdown(before))
  nodes.push({
    type: rule.type,
    children: rule.literal
      ? [{ type: 'text', value: match[1] }]
      : parseWhatsappMarkdown(match[1]),
  })
  if (after) nodes.push(...parseWhatsappMarkdown(after))

  return nodes
}

// Lê um conteúdo de metatag simples (não-aninhado, primeira ocorrência) e devolve
// já trimado, ou null. Usado pelos dados do link de pagamento HiperPay.
function getMetaTagContent(tag, message) {
  const re = new RegExp(`(?<=%${tag}%)([\\s\\S]*?)(?=%\\/${tag}%)`)
  const match = message.match(re)
  return match && match[0] != null ? match[0].trim() : null
}

// Extrai do payload os dados do link de pagamento HiperPay que dá pra reconstruir
// a vitrine no relatório (sem tocar no link real). Retorna null quando a mensagem
// não tem bloco de pagamento.
function getHiperPayData(message) {
  if (!message || !/%PaymentLink%/.test(message)) return null

  return {
    profileId: getMetaTagContent('ProfileId', message),
    price: getMetaTagContent('Price', message),
    pixCode: getMetaTagContent('PixCode', message),
    bankSlip: getMetaTagContent('BankSlip', message),
    thumbnail: getPaymentLinkThumbnail(message),
  }
}

export default {
  fillPlaceholders,
  tokenizeFilledText,
  parseWhatsappMarkdown,
  getHiperPayData,
  getFileFromMessage,
  clearMessage,
  formatMessage,
  getPaymentLinkThumbnail,
  getWhatsappCloudApiTemplateName,
  getWhatsappCloudApiTemplateData,
  getTemplateVariableLabels
}
